import React, { useState, useEffect, useRef } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import selectDownArrow from "../../../../assets/images/selectDownArrow.svg"; // Adjust this path as needed

const SharedCountryDropdown = ({
  label = "City",
  placeholder = "Select City",
  selectedCity,
  setSelectedCity,
  onCountryChange = () => {},
  disabled = false,
  countryCode = "",
}) => {
  const [cityOptions, setCityOptions] = useState([]);
  const [citySearch, setCitySearch] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
      
const getCitiesByCountry = async (countryCode) => {
  const response = await fetch(`https://api.countrystatecity.in/v1/countries/${countryCode}/cities`, {
    headers: { 'X-CSCAPI-KEY': 'M2JPOTBYbXRKY05MZ3ZiZFR5QnFMN2dlaGE2T29vQ2ZYSm43aEs1dQ==', }
  });
  

  if (response.ok) {
    const cities = await response.json()

    console.log(`Found ${cities.length} cities in ${countryCode}`);
    return cities;
  } else {
    console.error('Country not found or no cities available');
    return [];
  }
};

  // Fetch country vice city data
  const fetchCountries = React.useCallback(async () => {
    try {
      const res = await getCitiesByCountry(countryCode)

      if (Array.isArray(res)) {
        const sortedCities = res
          .map((item) => {
            const cities = item;

            return {
              label: cities?.name,
              value: cities?.name,
              country: countryCode,
            }
          })
          
        setCityOptions(sortedCities);
      }
    } catch (error) {
      console.error("Failed to fetch countries:", error);
    }
  }, [countryCode]);

  useEffect(() => {
    if (countryCode) {
      // setSelectedCity("");
      // setCitySearch("");
      fetchCountries();
    } else {
      setCityOptions([]);
      setSelectedCity("");
      setCitySearch("");
      onCountryChange({ name: "", country: "" });
      setDropdownOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode, fetchCountries]);

  // Handle country selection
  const handleCitySelect = (selectedName) => {
    const selected = cityOptions.find((c) => c.value === selectedName);
    // const currencyName = selected?.currency?.name || "";
    // const currencySymbol = selected?.currency?.symbol || "";

    setSelectedCity(selectedName);
    onCountryChange({
      name: selectedName,
      country: selected?.country,
      //   currency: currencyName ? `${currencyName} (${currencySymbol})` : "",
      //   currencySymbol,
      //   countryCode: selected?.code || "",
    });

    setCitySearch("");
    setDropdownOpen(false);
  };

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  const openDropdown = () => setDropdownOpen(true);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setCitySearch(selectedCity || "");
  }, [selectedCity]);

  return (
    <Form.Group className="custom-form">
      {label && <Form.Label className="color-head">{label}</Form.Label>}

      <div
        className={`country-dropdown-wrapper ${disabled ? "disabled" : ""}`}
        ref={dropdownRef}
        aria-disabled={disabled}
      >
        <InputGroup
          className="country-search-box"
          onClick={() => {
            if (!disabled) toggleDropdown();
          }}
        >
          <Form.Control
            type="text"
            className="country-input"
            placeholder={placeholder}
            value={citySearch}
            onChange={(e) => {
              const value = e.target.value;
              setCitySearch(value);
              if (!disabled) setDropdownOpen(true);

              if (cityOptions?.length === 0) {
                setSelectedCity(value);
                onCountryChange({
                  name: value,
                  country: countryCode,
                });
              }

              // NEW: Clear selectedCity & formData.region when emptied
              if (value.trim() === "") {
                setSelectedCity("");
                onCountryChange({
                  name: "",
                  country: "",
                  //   currency: "",
                  //   currencySymbol: "",
                  //   countryCode: "",
                });
              }
            }}
            // onFocus={() => {
            //   if (!disabled) openDropdown();
            // }}
            disabled={disabled}
          />
          <InputGroup.Text
            className="dropdown-arrow-wrapper"
            onClick={(e) => {
              e.stopPropagation();
              if (!disabled) openDropdown();
            }}
            style={{
              backgroundColor: "transparent",
              border: "none",
            }}
          >
            <img
              src={selectDownArrow}
              alt="CaretDown"
              className="dropdown-arrow"
            />
          </InputGroup.Text>
        </InputGroup>

        {dropdownOpen && (
          <div className="country-dropdown-list" role="listbox" aria-disabled={disabled}>
            {cityOptions
              .filter((item) =>
                item.label
                  .toLowerCase()
                  .includes(citySearch.toLowerCase().trim())
              )
              .map((item, idx) => (
                <div
                  key={idx}
                  onClick={() => {
                    if (!disabled) handleCitySelect(item.value);
                  }}
                  className={`country-option ${disabled ? "disabled" : ""}`}
                  role="option"
                  aria-selected={selectedCity === item.value}
                  tabIndex={disabled ? -1 : 0}
                >
                  {item.label}
                </div>
              ))}
          </div>
        )}
      </div>
    </Form.Group>
  );
};

export default SharedCountryDropdown;
